<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="SKU名称">
                <a-input v-model="queryParam.skuName" placeholder="请输入SKU名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="门店名称">
                <a-select v-model="queryParam.storeId" placeholder="请选择门店" allow-clear show-search
                  :filter-option="filterOption">
                  <a-select-option v-for="(item, index) in shopList" :value="item.id" :key="index">
                    {{ item.shopName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="预警状态">
                <a-select v-model="queryParam.alarmFlag" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">正常</a-select-option>
                  <a-select-option :value="1">预警</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['retail:inventory:export']">
          <a-icon type="download" />导出
        </a-button>
        <a-button type="danger" @click="$refs.returnForm.handleAdd()" v-hasPermi="['retail:inventory:storereturn']">
          <a-icon type="rollback" />门店退货
        </a-button>
      </div>

      <!-- 门店退货表单 -->
      <store-return-form ref="returnForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :bordered="tableBordered"
        @change="handleTableChange"
      >
        <span slot="goodsImage" slot-scope="text">
          <a-avatar shape="square" :size="64" :src="text" icon="shop" />
        </span>
        <span slot="stock" slot-scope="text">
          <a-tag :color="text > 0 ? 'green' : 'red'">{{ text || 0 }}</a-tag>
        </span>
        <span slot="alarmFlag" slot-scope="text">
          <a-tag :color="text === 1 ? 'red' : 'green'">{{ text === 1 ? '预警' : '正常' }}</a-tag>
        </span>
        <span slot="shopPrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="salePrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="plusPrice" slot-scope="text">
          ¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}
        </span>
        <span slot="createTime" slot-scope="text">
          {{ parseTime(text) }}
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getStorePurchaseInventoryList, exportStorePurchaseInventory } from '@/api/retail/inventory'
import { listShop } from '@/api/shop/shop'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'
import StoreReturnForm from '../inventory/modules/StoreReturnForm'

export default {
  name: 'StoreInventory',
  components: {
    StoreReturnForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      shopList: [],
      queryParam: {
        goodsName: undefined,
        skuName: undefined,
        storeId: undefined,
        alarmFlag: undefined,
        current: 1,
        size: 10
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 200,
          align: 'center'
        },
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 150,
          align: 'center'
        },
        {
          title: '门店名称',
          dataIndex: 'shopName',
          width: 150,
          align: 'center'
        },
        {
          title: '商品图片',
          dataIndex: 'goodsImage',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'goodsImage' }
        },
        {
          title: '当前库存',
          dataIndex: 'stock',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'stock' }
        },
        {
          title: '预警状态',
          dataIndex: 'alarmFlag',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'alarmFlag' }
        },
        {
          title: '门店拿货价(元)',
          dataIndex: 'shopPrice',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'shopPrice' }
        },
        {
          title: '门店销售价(元)',
          dataIndex: 'salePrice',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'salePrice' }
        },
        {
          title: 'PLUS会员价(元)',
          dataIndex: 'plusPrice',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'plusPrice' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        }
      ]
    }
  },
  created() {
    this.getShopList()
    this.getList()
  },
  methods: {
    moment,
    parseTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    getList() {
      this.loading = true
      getStorePurchaseInventoryList(this.queryParam).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.queryParam.current = pagination.current
      this.queryParam.size = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleQuery() {
      this.queryParam.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        goodsName: undefined,
        skuName: undefined,
        storeId: undefined,
        alarmFlag: undefined,
        current: 1,
        size: 10
      }
      this.getList()
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getShopList() {
      listShop({ shopType: 3 }).then(response => {
        this.shopList = response.data || []
      })
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('/api/retail/inventory/storePurchase/export', {
            ...that.queryParam
          }, `门店库存_${that.moment(new Date()).format('YYYYMMDDHHmmss')}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
